var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app container-fluid px-0"},[_c('preloader-component'),(_vm.canViewPublicRoutes || _vm.canViewAuthenticatedRoutes)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }